import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../../environment';

export const extModules = [StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production })];
